import { render, staticRenderFns } from "./GatherInfo.vue?vue&type=template&id=4dfb9df4&scoped=true&"
import script from "./GatherInfo.vue?vue&type=script&lang=js&"
export * from "./GatherInfo.vue?vue&type=script&lang=js&"
import style0 from "./GatherInfo.vue?vue&type=style&index=0&id=4dfb9df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb9df4",
  null
  
)

export default component.exports